module.exports = __webpack_public_path__ + "static/media/nas.c8e35ec3.png";